import { AsyncStoreItem } from '@lib/store';
import { GetDocumentListTktResponse } from 'src/sdk-servicing';

/**
 * GetDocumentListTkt model
 */
export interface GetDocumentListTktModel {
  model: GetDocumentListTktResponse | null;
}

/**
 * GetDocumentListTktResponse model details
 */
export interface GetDocumentListTktStateDetails extends AsyncStoreItem {}

/**
 * GetDocumentListTkt store state
 */
export interface GetDocumentListTktState extends GetDocumentListTktStateDetails, GetDocumentListTktModel {}

/**
 * Name of the GetDocumentListTkt Store
 */
export const GET_DOCUMENT_LIST_TKT_STORE_NAME = 'getDocumentListTkt';

/**
 * GetDocumentListTkt Store Interface
 */
export interface GetDocumentListTktStore {
  /** GetDocumentListTkt state */
  [GET_DOCUMENT_LIST_TKT_STORE_NAME]: GetDocumentListTktState;
}
